import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Debug en dev
if (process.env.NODE_ENV === 'development') {
  console.log('[Analytics Supabase] Init:', {
    url: supabaseUrl ? supabaseUrl.substring(0, 30) + '...' : 'MISSING',
    keyDefined: !!supabaseAnonKey
  });
}

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[Analytics] Supabase credentials missing. Analytics will not be recorded.');
  console.warn('[Analytics] Make sure .env.local contains REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY');
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

// Log si client créé
if (supabase && process.env.NODE_ENV === 'development') {
  console.log('[Analytics Supabase] Client created successfully');
}

/**
 * Crée ou met à jour une session analytics
 */
export async function upsertSession(sessionData) {
  if (!supabase) return null;

  const { data, error } = await supabase
    .from('analytics_sessions')
    .upsert(sessionData, { onConflict: 'session_id' })
    .select()
    .single();

  if (error) {
    console.error('Error upserting session:', error);
    return null;
  }
  return data;
}

/**
 * Insère un événement analytics
 */
export async function insertEvent(eventData) {
  if (!supabase) return null;

  const { data, error } = await supabase
    .from('analytics_events')
    .insert(eventData)
    .select()
    .single();

  if (error) {
    console.error('Error inserting event:', error);
    return null;
  }
  return data;
}

/**
 * Insère plusieurs événements en batch
 */
export async function insertEvents(events) {
  if (!supabase || events.length === 0) return [];

  const { data, error } = await supabase
    .from('analytics_events')
    .insert(events)
    .select();

  if (error) {
    console.error('Error inserting events:', error);
    return [];
  }
  return data;
}

/**
 * Met à jour une session existante
 */
export async function updateSession(sessionId, updates) {
  if (!supabase) return null;

  const { data, error } = await supabase
    .from('analytics_sessions')
    .update(updates)
    .eq('session_id', sessionId)
    .select()
    .single();

  if (error) {
    console.error('Error updating session:', error);
    return null;
  }
  return data;
}

export default supabase;
